/* eslint-disable no-nested-ternary */
export const ConditionalWrapper = ({ condition, wrapper, children, otherwise }) =>
  condition ? wrapper(children) : otherwise ? otherwise(children) : children
